// Single source of truth for the product being sold on this page.
// Update the name, price, and checkout link here — every purchase button reads from it.
export const product = {
  name: 'Pendulum Dowsing Toolkit™',
  price: 27,
  currency: 'USD',
  priceLabel: '$27 USD',
  checkoutUrl: 'https://pendulum-dowsing-toolkit.impultienda.ar/checkout',
}
